import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { cloudfish, login_image } from "../assets";
import { login_user_api } from "../DAL/Users";
import toast from "react-hot-toast";
import { useAuth } from "../hooks/useAuth";

const LoginPage = () => {
  const navigate = useNavigate();
  const { setUserInfo, userInfo, START_SOCKET_FORCEFULLY } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    const result = await login_user_api(formData);
    if (result.code === 200) {
      START_SOCKET_FORCEFULLY(result.user.id);
      localStorage.setItem("token", result.token);
      localStorage.setItem("user_info", JSON.stringify(result.user));
      setUserInfo(result.user);
      navigate(`/chatting`);
    } else {
      toast.error(`❌ ${result.message}`);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userInfo?.id) navigate(`/chatting`);
  }, [userInfo, navigate]);

  return (
    <div className="login-page">
      <div className="d-lg-flex">
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <div className="logo-box mb-3">
                <img src={cloudfish} alt="App Logo" className="login-logo" />
              </div>
              <h1>Chat App Login</h1>
              <p className="login-subtitle">
                Login to start chatting with colleagues
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className="input-wrapper">
                  <Icon icon="mdi:email-outline" className="input-icon" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className={errors.email ? "has-error" : ""}
                  />
                </div>
                {errors.email && (
                  <span className="error-message">
                    <Icon icon="mdi:alert-circle" className="error-icon" />
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Password */}
              <div className="form-group mt-2">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <Icon icon="mdi:lock-outline" className="input-icon" />
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className={errors.password ? "has-error" : ""}
                  />
                </div>
                {errors.password && (
                  <span className="error-message">
                    <Icon icon="mdi:alert-circle" className="error-icon" />
                    {errors.password}
                  </span>
                )}
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="theme-button mt-3"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Icon icon="mdi:loading" className="spin" />
                    Logging in...
                  </>
                ) : (
                  <>
                    <Icon icon="mdi:login" />
                    Login
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
        <div className="flex-1">
          <div
            className="login-image-container"
            style={{
              backgroundImage: `url(${login_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
